import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    numerex: null,
    hasChanges: false,
  },
  mutations: {
    setNumerex(state, numerex) {
      state.numerex = numerex;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setNumerex({ commit }, model) {
      commit('setNumerex', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getNumerex({ commit }, id) {
      PuzzleService.getPuzzleById(id).then(response => {
        commit('setNumerex', response);
        commit('setHasChanges', false);
      });
    },
  },
};
